import { render, staticRenderFns } from "./create-image.vue?vue&type=template&id=9f24e7ce&scoped=true"
import script from "./create-image.vue?vue&type=script&lang=js"
export * from "./create-image.vue?vue&type=script&lang=js"
import style0 from "./create-image.vue?vue&type=style&index=0&id=9f24e7ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_rj3s3qgubxnefw7btmb34khrpq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f24e7ce",
  null
  
)

export default component.exports